import { createAction, createReducer } from '@reduxjs/toolkit';
import { RESET_STATE } from '../../shared/actions/common-actions';
import { userLoadingAction } from './user-actions';

export const GET_USER = 'GET_USER';

type UserState = {
  userInfo: UserInfoState;
  isLoading: boolean;
};

export type UserInfoState = {
  userName: string;
  role: string[];
  token: object;
  kc: object;
  firstName: string;
  lastName: string;
  email: string;
};

const initialState: UserState = {
  userInfo: {
    userName: '',
    role: [],
    token: {},
    kc: {},
    firstName: '',
    lastName: '',
    email: '',
  },
  isLoading: false,
};

export const getUserAction = createAction<{
  token: object;
  tokenParsed: {
    preferred_username: string;
    given_name: string;
    family_name: string;
    email: string;
    resource_access: {
      maf_portal_security: { roles: string[] };
    };
  };
}>(GET_USER);

export default createReducer(initialState, (builder) => {
  builder
    .addCase(userLoadingAction, (state, action) => {
      state.isLoading = action.payload.isLoading;
    })
    .addCase(getUserAction, (state, action) => {
      state.userInfo = {
        userName: action.payload.tokenParsed.preferred_username,
        role: action.payload.tokenParsed.resource_access.maf_portal_security.roles,
        token: action.payload.token,
        kc: action.payload,
        firstName: action.payload.tokenParsed.given_name,
        lastName: action.payload.tokenParsed.family_name,
        email: action.payload.tokenParsed.email,
      };
    })
    .addCase(RESET_STATE, (state) => {
      state.isLoading = initialState.isLoading;
    });
});
